import * as Sentry from "@sentry/tanstackstart-react";

// Called once at app startup (browser only). No-ops if VITE_SENTRY_DSN is not set.
export function initSentry() {
  if (typeof window === "undefined") return;
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE ?? "production",
    integrations: [
      // TanStack Router-aware page navigation tracing
      Sentry.tanstackRouterBrowserTracingIntegration(),
      // Session replay: 5% of normal sessions, 100% on error
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Capture 20% of transactions for performance monitoring
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    // Filter known non-actionable browser noise
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured with value: Object Not Found Matching Id",
    ],
  });
}

export { Sentry };
